import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

import { useSession } from '../../providers/SessionProvider';

function RedirectRoute({ component: Component, ...rest }) {
  const { agent } = useSession();
  const location = useLocation();

  return (
    <Route
      {...rest}
      render={props => {
        if (agent) {
          return <Component {...props} />;
        }

        return (
          <Redirect
            to={{
              pathname: '/',
              state: {
                from: location,
              },
            }}
          />
        );
      }}
    />
  );
}

export default RedirectRoute;
